/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Upload: { input: any; output: any; }
};

export type Address = {
  __typename?: 'Address';
  countryName?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postcode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type AddressByType = {
  __typename?: 'AddressByType';
  postal?: Maybe<Address>;
  residential?: Maybe<Address>;
};

export type AddressByTypeInput = {
  postal?: InputMaybe<AddressInput>;
  residential?: InputMaybe<AddressInput>;
};

export type AddressInput = {
  countryName?: InputMaybe<Scalars['String']['input']>;
  line1?: InputMaybe<Scalars['String']['input']>;
  line2?: InputMaybe<Scalars['String']['input']>;
  postcode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  suburb?: InputMaybe<Scalars['String']['input']>;
};

export type Amount = {
  __typename?: 'Amount';
  fortnightly?: Maybe<Scalars['Float']['output']>;
  halfYearly?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  weekly?: Maybe<Scalars['Float']['output']>;
  yearly?: Maybe<Scalars['Float']['output']>;
};

export type ArchivedDocument = {
  __typename?: 'ArchivedDocument';
  archiveSource?: Maybe<Scalars['String']['output']>;
  communicationId?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  membershipId?: Maybe<Scalars['String']['output']>;
};

export type ArchivedDocumentInput = {
  archiveSource?: InputMaybe<Scalars['String']['input']>;
  communicationId?: InputMaybe<Scalars['String']['input']>;
  documentId?: InputMaybe<Scalars['String']['input']>;
  membershipId?: InputMaybe<Scalars['String']['input']>;
};

export type ArchivedDocumentUrl = {
  __typename?: 'ArchivedDocumentUrl';
  accessUrl?: Maybe<Scalars['String']['output']>;
};

export type AuthPayLoad = {
  __typename?: 'AuthPayLoad';
  access_token?: Maybe<Scalars['String']['output']>;
  expires_in?: Maybe<Scalars['Int']['output']>;
  membership?: Maybe<Membership>;
  refresh_token?: Maybe<Scalars['String']['output']>;
  token_type?: Maybe<Scalars['String']['output']>;
};

export type BankAccount = {
  __typename?: 'BankAccount';
  bsb: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  number: Scalars['String']['output'];
};

export type BankAccountInput = {
  bsb: Scalars['String']['input'];
  channel?: InputMaybe<ChannelType>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type BenefitEnquiryInput = {
  items: Array<InputMaybe<Item>>;
  memberId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
};

export type BenefitEnquiryResponse = {
  __typename?: 'BenefitEnquiryResponse';
  benefit?: Maybe<Scalars['Float']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  error?: Maybe<BenefitError>;
};

export type BenefitError = {
  __typename?: 'BenefitError';
  code?: Maybe<Scalars['String']['output']>;
  meta?: Maybe<Meta>;
};

export type BhcCertificate = {
  __typename?: 'BhcCertificate';
  conditionCode?: Maybe<Scalars['String']['output']>;
  conditionCodeDescription?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  expiresWithin30Days?: Maybe<Scalars['Boolean']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeDescription?: Maybe<Scalars['String']['output']>;
};

export type BsbInformation = {
  __typename?: 'BsbInformation';
  bankCode: Scalars['String']['output'];
  bankName: Scalars['String']['output'];
  bsb: Scalars['String']['output'];
};

export type BsbInput = {
  bsb: Scalars['String']['input'];
};

export type Card = {
  __typename?: 'Card';
  cardNumber?: Maybe<Scalars['String']['output']>;
  dateLastIssued?: Maybe<Scalars['String']['output']>;
  issueNumber?: Maybe<Scalars['ID']['output']>;
};

export type ChangeCover = {
  __typename?: 'ChangeCover';
  oneOffPayment?: Maybe<Scalars['Float']['output']>;
};

export type ChangeCoverInput = {
  state?: InputMaybe<Scalars['String']['input']>;
};

export type ChangeCoverResponse = {
  __typename?: 'ChangeCoverResponse';
  currentPrice?: Maybe<ProductPrice>;
  differenceToBePaid?: Maybe<Scalars['Float']['output']>;
  paysUntil?: Maybe<Scalars['String']['output']>;
  targetPrice?: Maybe<ProductPrice>;
};

export type ChangePasswordInput = {
  channel?: InputMaybe<ChannelType>;
  currentPassword: Scalars['String']['input'];
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
};

export enum ChannelType {
  Email = 'email',
  Sms = 'sms'
}

export type Charges = {
  __typename?: 'Charges';
  copayment?: Maybe<ChargesExcess>;
  excess?: Maybe<ChargesExcess>;
};

export type ChargesExcess = {
  __typename?: 'ChargesExcess';
  amount?: Maybe<Scalars['Float']['output']>;
  cappedAt?: Maybe<ExcessCappedAt>;
  waivers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Claim = {
  __typename?: 'Claim';
  benefitAmount: Scalars['Float']['output'];
  claimType?: Maybe<Scalars['String']['output']>;
  claimTypeLabel?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** @deprecated This is not being returned from the resolver so is not requestable */
  items?: Maybe<Array<Maybe<ClaimDetailItems>>>;
  memberId?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Float']['output'];
  paymentStatus: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  /** @deprecated Please use supportingDocument. */
  referralLetter?: Maybe<Scalars['Upload']['output']>;
  requiresHif?: Maybe<Scalars['Boolean']['output']>;
  serviceId?: Maybe<Scalars['String']['output']>;
  supportingDocument?: Maybe<Scalars['Upload']['output']>;
  totalOutOfPocket: Scalars['Float']['output'];
  trial?: Maybe<Scalars['Boolean']['output']>;
};

export type ClaimDetailItems = {
  __typename?: 'ClaimDetailItems';
  benefitAmount: Scalars['Float']['output'];
  bodyPart?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  claimItemType?: Maybe<Scalars['String']['output']>;
  dateReceived: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  drugDescription?: Maybe<Scalars['String']['output']>;
  hifStatus?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  isInitialPaidAsSubsequent?: Maybe<Scalars['Boolean']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  memberId?: Maybe<Scalars['String']['output']>;
  mimsCode?: Maybe<Scalars['String']['output']>;
  paidAmount: Scalars['Float']['output'];
  paymentStatus: Scalars['String']['output'];
  /** Note: Provider address is not implemented in claims details as there hasn't been a use case yet */
  provider?: Maybe<Provider>;
  quantity?: Maybe<Scalars['Int']['output']>;
  servicesQty?: Maybe<Scalars['Int']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  subCategory?: Maybe<Scalars['String']['output']>;
  totalOutOfPocket: Scalars['Float']['output'];
};

export type ClaimDetails = {
  __typename?: 'ClaimDetails';
  filteredByConsentStatus?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  items?: Maybe<Array<Maybe<ClaimDetailItems>>>;
  summary?: Maybe<ClaimSummary>;
};

export type ClaimDetailsInput = {
  id: Scalars['ID']['input'];
};

export type ClaimHistoryAllInput = {
  isRefetch?: InputMaybe<Scalars['Boolean']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
  yearToBeFetched: Scalars['Int']['input'];
};

export type ClaimHistoryInput = {
  dateFrom?: InputMaybe<Scalars['String']['input']>;
  dateTo?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['ID']['input']>;
};

export type ClaimItemsInput = {
  bodyPart?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  drugDescription?: InputMaybe<Scalars['String']['input']>;
  itemCode?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['ID']['input']>;
  mimsCode?: InputMaybe<Scalars['String']['input']>;
  paidAmount?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ClaimSummary = {
  __typename?: 'ClaimSummary';
  benefitAmount?: Maybe<Scalars['Float']['output']>;
  claimType?: Maybe<Scalars['String']['output']>;
  claimTypeLabel?: Maybe<Scalars['String']['output']>;
  dateReceived?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  paidAmount?: Maybe<Scalars['Float']['output']>;
  paymentStatus?: Maybe<Scalars['String']['output']>;
  totalOutOfPocket?: Maybe<Scalars['Float']['output']>;
};

export enum ClaimType {
  Ambulance = 'ambulance',
  Hospital = 'hospital',
  Medical = 'medical'
}

export type ClinicalCategories = {
  __typename?: 'ClinicalCategories';
  excluded?: Maybe<Array<Maybe<ClinicalCategory>>>;
  included?: Maybe<Array<Maybe<ClinicalCategory>>>;
  restricted?: Maybe<Array<Maybe<ClinicalCategory>>>;
};

export type ClinicalCategory = {
  __typename?: 'ClinicalCategory';
  description: Scalars['String']['output'];
  example?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  supportingCopy?: Maybe<Scalars['String']['output']>;
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type CommunicationPreferences = {
  __typename?: 'CommunicationPreferences';
  primaryContactByEmail?: Maybe<Scalars['Boolean']['output']>;
  receiveMarketing?: Maybe<ReceiveMarketing>;
};

export type ComposedProducts = {
  __typename?: 'ComposedProducts';
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
};

export type CoverChange = {
  __typename?: 'CoverChange';
  productId?: Maybe<Scalars['String']['output']>;
  rebate?: Maybe<MembershipRebate>;
  scale?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type CoverChangesInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type CoverChangesResponse = {
  __typename?: 'CoverChangesResponse';
  errors?: Maybe<Array<Maybe<Error>>>;
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  payload?: Maybe<Array<Maybe<CoverChange>>>;
};

export type CreateClaimInput = {
  creditAccount?: InputMaybe<BankAccountInput>;
  date?: InputMaybe<Scalars['String']['input']>;
  items?: InputMaybe<Array<InputMaybe<ClaimItemsInput>>>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  receipts?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
  requiresHif?: InputMaybe<Scalars['Boolean']['input']>;
  serviceId?: InputMaybe<Scalars['String']['input']>;
  supportingDocument?: InputMaybe<Scalars['Upload']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateMedicalHospitalClaimInput = {
  claimType: ClaimType;
  documents: Array<InputMaybe<Scalars['Upload']['input']>>;
};

export type CustomerNotifications = {
  __typename?: 'CustomerNotifications';
  checkDetails: Scalars['Boolean']['output'];
};

export type DirectDebitDetails = {
  __typename?: 'DirectDebitDetails';
  account?: Maybe<Scalars['String']['output']>;
  bsb?: Maybe<Scalars['String']['output']>;
  cardExpiry?: Maybe<Scalars['String']['output']>;
  /** masked card number as '•••• •••• •••• 4242' */
  cardNumber?: Maybe<Scalars['String']['output']>;
  /** visa, mastercard */
  cardType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DirectDebitDetailsInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bsb?: InputMaybe<Scalars['String']['input']>;
  cardExpiry?: InputMaybe<Scalars['String']['input']>;
  cardType?: InputMaybe<Scalars['String']['input']>;
  directDebitType: Scalars['String']['input'];
  name: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};

export type Document = {
  __typename?: 'Document';
  archivedDocument?: Maybe<ArchivedDocument>;
  date?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  memberId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<DocumentTitle>;
  type?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type DocumentTitle = {
  __typename?: 'DocumentTitle';
  full?: Maybe<Scalars['String']['output']>;
  redacted?: Maybe<Scalars['String']['output']>;
};

export type DrugSearchInput = {
  brandGeneric: Scalars['String']['input'];
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type ExcessCappedAt = {
  __typename?: 'ExcessCappedAt';
  individual?: Maybe<Scalars['Float']['output']>;
  per?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Scalars['Float']['output']>;
};

export type ExtraService = {
  __typename?: 'ExtraService';
  annualLimit?: Maybe<ExtrasAnnualLimits>;
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  /** @deprecated Please use serviceId as id is automatically normalized and we don't want that for dynamic service limits. */
  id: Scalars['String']['output'];
  items?: Maybe<Array<Maybe<ExtraServiceItem>>>;
  limits?: Maybe<ExtrasLimitsConsumed>;
  name: Scalars['String']['output'];
  servedWaitingPeriod?: Maybe<ServedWaitingPeriod>;
  serviceId: Scalars['ID']['output'];
  shortName?: Maybe<Scalars['String']['output']>;
  subtitle: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /**
   * Waiting Periods at serviceGroup level are derived, not source of truth.
   * They are grouped at this level to make the information more digestible by users.
   * They are actually configured on the *item* level in WHICS and therefore can be different within one serviceGroup.
   */
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type ExtraServiceItem = {
  __typename?: 'ExtraServiceItem';
  code?: Maybe<Scalars['String']['output']>;
  /** items removed by government PHI reform; several natural therapy items */
  decommissioned?: Maybe<Scalars['Boolean']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** Waiting period at the item level is used to calculate the overall status of the service. */
  servedWaitingPeriod?: Maybe<ServedWaitingPeriod>;
  unit?: Maybe<Scalars['String']['output']>;
  /** this is the value back. E.g. 70, $50 */
  value: Scalars['Float']['output'];
  /**
   * it can be shared between multiple services.
   * Items inside the same service can have different waiting period. See super extras Podiatry
   */
  waitingPeriod?: Maybe<WaitingPeriod>;
};

export type ExtrasAnnualLimits = {
  __typename?: 'ExtrasAnnualLimits';
  conditions?: Maybe<ExtrasLimitConditions>;
  family?: Maybe<Scalars['Float']['output']>;
  individual?: Maybe<Scalars['Float']['output']>;
  lifetime?: Maybe<Scalars['Float']['output']>;
};

export type ExtrasLimitConditions = {
  __typename?: 'ExtrasLimitConditions';
  restrictedInitialConsultation?: Maybe<Scalars['Boolean']['output']>;
};

export type ExtrasLimits = {
  __typename?: 'ExtrasLimits';
  amount?: Maybe<Scalars['Int']['output']>;
  applicableAfterYears?: Maybe<Scalars['Int']['output']>;
};

export type ExtrasLimitsConsumed = {
  __typename?: 'ExtrasLimitsConsumed';
  category?: Maybe<Scalars['String']['output']>;
  dateReset?: Maybe<Scalars['String']['output']>;
  extrasLimitId: Scalars['ID']['output'];
  family?: Maybe<LimitItem>;
  individual?: Maybe<LimitItem>;
  lifetime?: Maybe<LimitItem>;
  memberId: Scalars['ID']['output'];
};

/** Extras product and all attributes, services, items, waiting period and limits. */
export type ExtrasServiceGroup = {
  __typename?: 'ExtrasServiceGroup';
  /** Flexi products share on single limit, for example, "essentials flexi basic plus". Limit ID and category from Whics is "single-limit-combined" */
  annualLimit?: Maybe<ExtrasAnnualLimits>;
  description?: Maybe<Scalars['String']['output']>;
  extrasLimitDisplayName: Scalars['String']['output'];
  extrasLimitId: Scalars['ID']['output'];
  isUnlimited?: Maybe<Scalars['Boolean']['output']>;
  limits?: Maybe<ExtrasLimitsConsumed>;
  servedWaitingPeriod?: Maybe<ServedWaitingPeriod>;
  services: Array<ExtraService>;
};

export type ExtrasServiceGroupResponse = {
  __typename?: 'ExtrasServiceGroupResponse';
  /** @deprecated Please use error variable at the client. Inspect variable data for partial data responses. */
  errors?: Maybe<Array<Maybe<Error>>>;
  /** @deprecated Please use error variable at the client. Inspect variable data for partial data responses. */
  hasErrors?: Maybe<Scalars['Boolean']['output']>;
  individualRolloverLimitSum?: Maybe<Scalars['Float']['output']>;
  payload?: Maybe<Array<Maybe<ExtrasServiceGroup>>>;
};

export type FindDoctorsResults = {
  __typename?: 'FindDoctorsResults';
  address?: Maybe<ProviderAddress>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber: Scalars['ID']['output'];
};

export type FindHospitalsResults = {
  __typename?: 'FindHospitalsResults';
  address?: Maybe<ProviderAddress>;
  contractType?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  providerNumber: Scalars['ID']['output'];
};

export type FindProviders = {
  __typename?: 'FindProviders';
  count: Scalars['Int']['output'];
  pageNumber: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  results: Array<Maybe<FindProvidersResultTypes>>;
  searchType: SearchTypes;
};

export type FindProvidersInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pageNumber?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  providerNumber?: InputMaybe<Scalars['String']['input']>;
  searchType: SearchTypes;
  specialty?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FindProvidersResultTypes = FindDoctorsResults | FindHospitalsResults | FindProvidersResults;

export type FindProvidersResults = {
  __typename?: 'FindProvidersResults';
  address?: Maybe<ProviderAddress>;
  name: Scalars['String']['output'];
  noGapDental?: Maybe<Scalars['Boolean']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  providerNumber: Scalars['ID']['output'];
};

export type GenerateTaxStatementInput = {
  deliveryMode: Scalars['String']['input'];
  financialYear: Scalars['Int']['input'];
  memberIds: Array<InputMaybe<Scalars['String']['input']>>;
};

export type GetAppDemoModeCodeInput = {
  demoModeToken: Scalars['String']['input'];
  demoModeUser: Scalars['String']['input'];
};

export type GuideUrl = {
  __typename?: 'GuideUrl';
  ambulance?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
  package?: Maybe<Scalars['String']['output']>;
};

export type Hospital = {
  __typename?: 'Hospital';
  clinicalCategories?: Maybe<ClinicalCategories>;
};

export type HospitalCoverCheckAutomatedInput = {
  dateOfAdmission: Scalars['String']['input'];
  hospitalBeingAdmittedTo: Scalars['String']['input'];
  hospitalBeingAdmittedToLine1: Scalars['String']['input'];
  hospitalBeingAdmittedToPostCode: Scalars['String']['input'];
  hospitalBeingAdmittedToState: Scalars['String']['input'];
  hospitalBeingAdmittedToSuburb: Scalars['String']['input'];
  hospitalProviderNumber: Scalars['String']['input'];
  mbsItemCodes: Scalars['String']['input'];
  medicareCardColor: Scalars['String']['input'];
  memberBeingAdmitted: Scalars['String']['input'];
  nameOnMedicareCard: Scalars['String']['input'];
  nightsOfAdmission?: InputMaybe<Scalars['String']['input']>;
};

export type HospitalCoverCheckAutomatedResponse = {
  __typename?: 'HospitalCoverCheckAutomatedResponse';
  excessDescription?: Maybe<Scalars['String']['output']>;
  outcome: Scalars['String']['output'];
};

export type HospitalSearchInput = {
  location?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Hoyts = {
  __typename?: 'Hoyts';
  url: Scalars['String']['output'];
};

export type Item = {
  code: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  quantity: Scalars['Int']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  id: Scalars['ID']['output'];
};

export type LimitItem = {
  __typename?: 'LimitItem';
  limit?: Maybe<Scalars['Float']['output']>;
  percent?: Maybe<Scalars['Float']['output']>;
  remaining?: Maybe<Scalars['Float']['output']>;
  rolloverLimit?: Maybe<Scalars['Float']['output']>;
  spent?: Maybe<Scalars['Float']['output']>;
  standardLimit?: Maybe<Scalars['Float']['output']>;
  standardRemaining?: Maybe<Scalars['Float']['output']>;
};

export type LimitsInput = {
  joinDate: Scalars['String']['input'];
  memberId: Scalars['ID']['input'];
  productId: Scalars['String']['input'];
};

export type LimitsRollover = {
  __typename?: 'LimitsRollover';
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isEligibleForFamily?: Maybe<Scalars['Boolean']['output']>;
};

export type LivePersonAuthInput = {
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};

export type LivePersonPayLoad = {
  __typename?: 'LivePersonPayLoad';
  expiresIn: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type Medicare = {
  __typename?: 'Medicare';
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type MedicareCard = {
  __typename?: 'MedicareCard';
  expiry?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type Member = {
  __typename?: 'Member';
  /** Optical certificates are filtered out as well as certificates for members who have not provided consent */
  bhcCertificates?: Maybe<Array<Maybe<BhcCertificate>>>;
  card?: Maybe<Card>;
  certifiedAge?: Maybe<Scalars['Int']['output']>;
  /** consentStatus is for extras claims consent */
  consentStatus?: Maybe<Scalars['String']['output']>;
  continuous?: Maybe<Scalars['Boolean']['output']>;
  dateOfBirth: Scalars['String']['output'];
  email?: Maybe<Scalars['String']['output']>;
  enrolCode?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  gender?: Maybe<Scalars['String']['output']>;
  /** hasGivenPersonalInformationAndClaimsConsent can be used as consent for looking up a members hospital claims */
  hasGivenPersonalInformationAndClaimsConsent?: Maybe<Scalars['Boolean']['output']>;
  hasObtainedTransferCertificate?: Maybe<Scalars['Boolean']['output']>;
  joinDate?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  medicare?: Maybe<MedicareCard>;
  memberId: Scalars['ID']['output'];
  memberStatus: Scalars['String']['output'];
  /** PatientId is displayed on digital card page for claiming purposes */
  patientId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Phone>;
  relationship: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type MemberEmailPhoneInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export type MembersPriceInput = {
  certifiedAge?: InputMaybe<Scalars['Int']['input']>;
  continuous?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  relationship?: InputMaybe<Scalars['String']['input']>;
};

export type Membership = {
  __typename?: 'Membership';
  address?: Maybe<AddressByType>;
  ambulanceSurchargeExempted?: Maybe<Scalars['Boolean']['output']>;
  campaignCode?: Maybe<Scalars['String']['output']>;
  communicationPreferences?: Maybe<CommunicationPreferences>;
  coverCampaignCode?: Maybe<Scalars['String']['output']>;
  creditAccount?: Maybe<BankAccount>;
  customerNotifications?: Maybe<CustomerNotifications>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fund?: Maybe<Scalars['String']['output']>;
  hasSurcharge?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  joinDate?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  lhc?: Maybe<Scalars['Float']['output']>;
  limitsRollover?: Maybe<LimitsRollover>;
  medicare?: Maybe<Medicare>;
  members?: Maybe<Array<Maybe<Member>>>;
  onboarding?: Maybe<Onboarding>;
  paidToDate?: Maybe<Scalars['String']['output']>;
  paymentDetails?: Maybe<PaymentDetails>;
  payments?: Maybe<Payments>;
  phone?: Maybe<Phone>;
  policy?: Maybe<MembershipPolicy>;
  product?: Maybe<Product>;
  rateCode?: Maybe<Scalars['String']['output']>;
  rebate?: Maybe<MembershipRebate>;
  referralCode?: Maybe<Scalars['String']['output']>;
  returnMail?: Maybe<Scalars['Boolean']['output']>;
  scale?: Maybe<Scalars['String']['output']>;
  spouseAuthority?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  suspendedDetails?: Maybe<SuspendedDetails>;
  youthDiscount?: Maybe<YouthDiscount>;
};

export type MembershipPolicy = {
  __typename?: 'MembershipPolicy';
  changedDates: ServiceDates;
  resetDates: ServiceDates;
  state: Scalars['String']['output'];
};

export type MembershipRebate = {
  __typename?: 'MembershipRebate';
  incomeTier?: Maybe<Scalars['String']['output']>;
  isActive?: Maybe<Scalars['Boolean']['output']>;
  isApplied?: Maybe<Scalars['Boolean']['output']>;
  isPending?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
  savingsProvisionsAgeBracket?: Maybe<Scalars['String']['output']>;
};

export type Meta = {
  __typename?: 'Meta';
  dateReset?: Maybe<Scalars['String']['output']>;
  futureBenefit?: Maybe<Scalars['Float']['output']>;
  waitingPeriodEndDate?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  changePassword?: Maybe<Scalars['String']['output']>;
  createClaim?: Maybe<Claim>;
  createLead?: Maybe<Lead>;
  createMedicalHospitalClaim: Scalars['String']['output'];
  generateTaxStatement?: Maybe<Scalars['String']['output']>;
  getAppDemoModeCode: Scalars['String']['output'];
  hospitalCoverCheckAutomated?: Maybe<HospitalCoverCheckAutomatedResponse>;
  livePersonAuth: LivePersonPayLoad;
  loginUser: AuthPayLoad;
  logoutUser?: Maybe<Scalars['String']['output']>;
  npsRequestACallFeedback: Scalars['Boolean']['output'];
  pauseCover?: Maybe<Scalars['String']['output']>;
  registerUser: RegisterPayLoad;
  reissueCard?: Maybe<ReissueCardResponse>;
  sendMfa?: Maybe<Scalars['String']['output']>;
  setOnboardingDismissed?: Maybe<Scalars['String']['output']>;
  updateCommunicationPreferences?: Maybe<CommunicationPreferences>;
  updateCreditAccount?: Maybe<Membership>;
  updateDirectDebitDetails?: Maybe<NewDirectDebitDetails>;
  updateIncomeTier?: Maybe<Membership>;
  updateMember?: Maybe<Member>;
  updateMembers?: Maybe<Array<Maybe<Member>>>;
  updatePaymentFrequency?: Maybe<NewDirectDebitDetails>;
  updatePrimaryMember?: Maybe<Membership>;
  uploadDocuments?: Maybe<Scalars['String']['output']>;
};


export type MutationChangePasswordArgs = {
  input?: InputMaybe<ChangePasswordInput>;
};


export type MutationCreateClaimArgs = {
  input?: InputMaybe<CreateClaimInput>;
};


export type MutationCreateLeadArgs = {
  input?: InputMaybe<CreateLeadInput>;
};


export type MutationCreateMedicalHospitalClaimArgs = {
  input?: InputMaybe<CreateMedicalHospitalClaimInput>;
};


export type MutationGenerateTaxStatementArgs = {
  input: GenerateTaxStatementInput;
};


export type MutationGetAppDemoModeCodeArgs = {
  input?: InputMaybe<GetAppDemoModeCodeInput>;
};


export type MutationHospitalCoverCheckAutomatedArgs = {
  input?: InputMaybe<HospitalCoverCheckAutomatedInput>;
};


export type MutationLivePersonAuthArgs = {
  input?: InputMaybe<LivePersonAuthInput>;
};


export type MutationLoginUserArgs = {
  input?: InputMaybe<UserLoginInput>;
};


export type MutationNpsRequestACallFeedbackArgs = {
  input?: InputMaybe<NpsRequestACallFeedbackInput>;
};


export type MutationPauseCoverArgs = {
  input?: InputMaybe<PauseCoverInput>;
};


export type MutationRegisterUserArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationReissueCardArgs = {
  input?: InputMaybe<ReissueCardInput>;
};


export type MutationSendMfaArgs = {
  input?: InputMaybe<SendMfaInput>;
};


export type MutationUpdateCommunicationPreferencesArgs = {
  input?: InputMaybe<UpdateCommunicationPreferencesInput>;
};


export type MutationUpdateCreditAccountArgs = {
  input?: InputMaybe<UpdateCreditAccountInput>;
};


export type MutationUpdateDirectDebitDetailsArgs = {
  input?: InputMaybe<DirectDebitDetailsInput>;
};


export type MutationUpdateIncomeTierArgs = {
  input?: InputMaybe<UpdateIncomeTierInput>;
};


export type MutationUpdateMemberArgs = {
  input?: InputMaybe<UpdateMemberInput>;
};


export type MutationUpdateMembersArgs = {
  input?: InputMaybe<UpdateMembersInput>;
};


export type MutationUpdatePaymentFrequencyArgs = {
  input?: InputMaybe<UpdatePaymentFrequencyInput>;
};


export type MutationUpdatePrimaryMemberArgs = {
  input?: InputMaybe<UpdatePrimaryMemberInput>;
};


export type MutationUploadDocumentsArgs = {
  input: UploadDocumentsInput;
};

export type NewDirectDebitDetails = {
  __typename?: 'NewDirectDebitDetails';
  hasSurcharge?: Maybe<Scalars['Boolean']['output']>;
  nextDeduction?: Maybe<Scalars['Float']['output']>;
  nextDeductionWithSurcharge?: Maybe<Scalars['Float']['output']>;
  regularAmount?: Maybe<Scalars['Float']['output']>;
  regularAmountWithSurcharge?: Maybe<Scalars['Float']['output']>;
};

export type NpsRequestACallFeedbackInput = {
  callbackTime: Scalars['String']['input'];
  isMember: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  tellUsMore: Scalars['String']['input'];
};

export type Onboarding = {
  __typename?: 'Onboarding';
  isApplicable?: Maybe<Scalars['Boolean']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
};

export type OnboardingInput = {
  joinDate: Scalars['String']['input'];
  productType?: InputMaybe<Scalars['String']['input']>;
};

export type PauseCoverInput = {
  dateFrom: Scalars['String']['input'];
  dateTo: Scalars['String']['input'];
  supportingDocuments?: InputMaybe<Array<InputMaybe<Scalars['Upload']['input']>>>;
};

export type PauseCoverPeriod = {
  __typename?: 'PauseCoverPeriod';
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateSubmitted?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
};

export type PaymentDatePaidTo = {
  __typename?: 'PaymentDatePaidTo';
  next?: Maybe<PaymentsNext>;
};

export type PaymentDatePaidToInput = {
  date?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentDetails = {
  __typename?: 'PaymentDetails';
  bsb?: Maybe<Scalars['String']['output']>;
  frequency?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistory = {
  __typename?: 'PaymentHistory';
  list?: Maybe<Array<Maybe<PaymentHistoryItem>>>;
  nextPagePointer?: Maybe<Scalars['String']['output']>;
  pageSize?: Maybe<Scalars['String']['output']>;
};

export type PaymentHistoryInput = {
  nextPagePointer?: InputMaybe<Scalars['String']['input']>;
  pageSize?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentHistoryItem = {
  __typename?: 'PaymentHistoryItem';
  amount: Scalars['Float']['output'];
  dateReceipt: Scalars['String']['output'];
  hasReceipt?: Maybe<Scalars['Boolean']['output']>;
  reference: Scalars['ID']['output'];
  requestedFromPagePointer?: Maybe<Scalars['String']['output']>;
  transferType: Scalars['String']['output'];
};

export type PaymentStatus = {
  __typename?: 'PaymentStatus';
  directDebitPaymentHistory?: Maybe<DirectDebitDetails>;
  reason?: Maybe<Scalars['String']['output']>;
  reasonDescription?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type Payments = {
  __typename?: 'Payments';
  arrears?: Maybe<Scalars['Float']['output']>;
  directDebitDetails?: Maybe<DirectDebitDetails>;
  directDebitType?: Maybe<Scalars['String']['output']>;
  frequency: Scalars['String']['output'];
  next?: Maybe<PaymentsNext>;
  paymentStatus?: Maybe<PaymentStatus>;
  regular: PaymentsRegular;
};

export type PaymentsNext = {
  __typename?: 'PaymentsNext';
  date?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Float']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PaymentsRegular = {
  __typename?: 'PaymentsRegular';
  subtotal?: Maybe<Scalars['Float']['output']>;
  surcharge?: Maybe<Scalars['Float']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
};

export type PendingClaim = {
  __typename?: 'PendingClaim';
  dateReceived?: Maybe<Scalars['String']['output']>;
};

export type PharmacyItem = {
  __typename?: 'PharmacyItem';
  benefitRule?: Maybe<Scalars['String']['output']>;
  drugDescription?: Maybe<Scalars['String']['output']>;
  itemCode?: Maybe<Scalars['String']['output']>;
  mimsCode?: Maybe<Scalars['String']['output']>;
  packNumber?: Maybe<Scalars['Int']['output']>;
  packSize?: Maybe<Scalars['Int']['output']>;
};

export type PharmacyItems = {
  __typename?: 'PharmacyItems';
  items?: Maybe<Array<Maybe<PharmacyItem>>>;
  strength?: Maybe<Scalars['String']['output']>;
};

export type PharmacyItemsSearch = {
  __typename?: 'PharmacyItemsSearch';
  brandName?: Maybe<Scalars['String']['output']>;
  drugType?: Maybe<Scalars['String']['output']>;
  genericName?: Maybe<Scalars['String']['output']>;
  strengths?: Maybe<Array<Maybe<PharmacyItems>>>;
};

export type Phone = {
  __typename?: 'Phone';
  home?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  work?: Maybe<Scalars['String']['output']>;
};

export type PhoneEmailDuplication = {
  __typename?: 'PhoneEmailDuplication';
  emailDuplication?: Maybe<Scalars['Boolean']['output']>;
  phoneDuplication?: Maybe<Scalars['Boolean']['output']>;
};

export type PhoneInput = {
  home?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  work?: InputMaybe<Scalars['String']['input']>;
};

export type PriceParams = {
  ageBracket?: InputMaybe<Scalars['String']['input']>;
  ambulanceSurchargeExempted?: InputMaybe<Scalars['Boolean']['input']>;
  clientYouthDiscountAge?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  fund?: InputMaybe<Scalars['String']['input']>;
  incomeTier?: InputMaybe<Scalars['String']['input']>;
  members?: InputMaybe<Array<InputMaybe<MembersPriceInput>>>;
  rateCode?: InputMaybe<Scalars['String']['input']>;
  rebate?: InputMaybe<Scalars['Boolean']['input']>;
  reload?: InputMaybe<Scalars['Boolean']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  spouseYouthDiscountAge?: InputMaybe<Scalars['Int']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Product = {
  __typename?: 'Product';
  charges?: Maybe<Charges>;
  composedProducts?: Maybe<ComposedProducts>;
  content?: Maybe<ProductContent>;
  extras?: Maybe<Array<Maybe<ExtrasServiceGroup>>>;
  extrasLimits?: Maybe<Array<Maybe<ExtrasLimits>>>;
  extrasType?: Maybe<Scalars['String']['output']>;
  features?: Maybe<ProductFeatures>;
  guideUrl?: Maybe<GuideUrl>;
  hospital?: Maybe<Hospital>;
  hospitalTier?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  loyalty?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  name: Scalars['String']['output'];
  nameExtras?: Maybe<Scalars['String']['output']>;
  nameHospital?: Maybe<Scalars['String']['output']>;
  /** This is the parent product related to the hospital component */
  parentProductId?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<ProductPrice>;
  rank?: Maybe<Scalars['Int']['output']>;
  rating?: Maybe<Rating>;
  relatedProducts?: Maybe<RelatedProducts>;
  scales?: Maybe<Scales>;
  shortName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ProductContent = {
  __typename?: 'ProductContent';
  benefits?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  highlights?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  longForm?: Maybe<Scalars['String']['output']>;
  tierDescription?: Maybe<Scalars['String']['output']>;
};

export type ProductFeatures = {
  __typename?: 'ProductFeatures';
  noGapDental?: Maybe<Scalars['Boolean']['output']>;
  noGapDentalLimited?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  amount?: Maybe<Amount>;
  fortnightly?: Maybe<Scalars['Float']['output']>;
  halfYearly?: Maybe<Scalars['Float']['output']>;
  lhc?: Maybe<Scalars['Float']['output']>;
  monthly?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['String']['output']>;
  quarterly?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  weekly?: Maybe<Scalars['Float']['output']>;
  yearly?: Maybe<Scalars['Float']['output']>;
  youthDiscount?: Maybe<Scalars['Float']['output']>;
};

export enum ProductType {
  Extras = 'extras',
  Hospital = 'hospital'
}

export type ProductWithServiceInput = {
  productType: ProductType;
  serviceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ProductsWithPricesInput = {
  priceParams?: InputMaybe<PriceParams>;
  productIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type Provider = {
  __typename?: 'Provider';
  address?: Maybe<ProviderAddress>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type ProviderAddress = {
  __typename?: 'ProviderAddress';
  country?: Maybe<Scalars['String']['output']>;
  line1: Scalars['String']['output'];
  line2: Scalars['String']['output'];
  postcode: Scalars['String']['output'];
  state: Scalars['String']['output'];
  suburb: Scalars['String']['output'];
};

export type ProviderSearchInput = {
  groupId?: InputMaybe<Scalars['String']['input']>;
  isFilteringExcludedProviders?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['String']['input']>;
  q: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  bsbInformation?: Maybe<BsbInformation>;
  checkWaitingPeriodForItem?: Maybe<WaitingPeriodForItem>;
  claimDetails?: Maybe<ClaimDetails>;
  /**
   * It returns all members if no memberId is supplied
   * It returns the last 3 years if no fromDate and toDate are supplied
   */
  claimHistory?: Maybe<Array<Maybe<Claim>>>;
  claimHistoryAll?: Maybe<ClaimHistoryAllResults>;
  coverChanges?: Maybe<CoverChangesResponse>;
  /** @deprecated Please use getExtrasServiceGroups operation */
  extrasServiceGroups?: Maybe<Array<Maybe<ExtrasServiceGroup>>>;
  extrasServiceGroupsWithPayload?: Maybe<ExtrasServiceGroupResponse>;
  findProviders?: Maybe<FindProviders>;
  generateReceipt?: Maybe<Receipt>;
  getArchivedDocumentUrl?: Maybe<ArchivedDocumentUrl>;
  getChangeCoverPrices?: Maybe<ChangeCoverResponse>;
  getDocuments?: Maybe<Array<Maybe<Document>>>;
  getHoytsUrl: Hoyts;
  getOnboarding?: Maybe<Onboarding>;
  getServices?: Maybe<Array<Maybe<Service>>>;
  hello: Scalars['String']['output'];
  hospitalSearch?: Maybe<Array<Maybe<FindHospitalsResults>>>;
  /** @deprecated Please use extrasServiceGroupsWithPayload operation */
  limits?: Maybe<Array<Maybe<ExtrasLimitsConsumed>>>;
  members?: Maybe<Array<Maybe<Member>>>;
  membership?: Maybe<Membership>;
  pauseCoverRequest?: Maybe<PauseCoverPeriod>;
  paymentDatePaidTo?: Maybe<PaymentDatePaidTo>;
  /** @deprecated Please use paymentHistoryWithPagination operation */
  paymentHistory?: Maybe<Array<Maybe<PaymentHistoryItem>>>;
  paymentHistoryWithPagination?: Maybe<PaymentHistory>;
  pendingClaims?: Maybe<Array<Maybe<PendingClaim>>>;
  performBenefitEnquiry?: Maybe<Array<Maybe<BenefitEnquiryResponse>>>;
  pharmacyItemsSearch?: Maybe<Array<Maybe<PharmacyItemsSearch>>>;
  product?: Maybe<Product>;
  productsWithPrices?: Maybe<Array<Maybe<Product>>>;
  productsWithServices?: Maybe<Array<Scalars['ID']['output']>>;
  /** It searches for providers using .NET legacy API. */
  providerSearch?: Maybe<Array<Maybe<Provider>>>;
  recommendProducts: RecommendProducts;
  referralHistory?: Maybe<Array<Maybe<ReferralHistoryItem>>>;
  resolveProductId?: Maybe<Scalars['String']['output']>;
  servedWaitingPeriods?: Maybe<Array<Maybe<ServedWaitingPeriod>>>;
  validatePhoneAndEmailDuplication?: Maybe<PhoneEmailDuplication>;
  validateReferralCode?: Maybe<ValidatedReferralCode>;
};


export type QueryBsbInformationArgs = {
  input?: InputMaybe<BsbInput>;
};


export type QueryCheckWaitingPeriodForItemArgs = {
  input: WaitingPeriodForItemInput;
};


export type QueryClaimDetailsArgs = {
  input?: InputMaybe<ClaimDetailsInput>;
};


export type QueryClaimHistoryArgs = {
  input?: InputMaybe<ClaimHistoryInput>;
};


export type QueryClaimHistoryAllArgs = {
  input?: InputMaybe<ClaimHistoryAllInput>;
};


export type QueryCoverChangesArgs = {
  input?: InputMaybe<CoverChangesInput>;
};


export type QueryExtrasServiceGroupsArgs = {
  fetchWaitingPeriods?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<LimitsInput>;
};


export type QueryExtrasServiceGroupsWithPayloadArgs = {
  fetchWaitingPeriods?: InputMaybe<Scalars['Boolean']['input']>;
  input?: InputMaybe<LimitsInput>;
};


export type QueryFindProvidersArgs = {
  input?: InputMaybe<FindProvidersInput>;
};


export type QueryGenerateReceiptArgs = {
  input?: InputMaybe<ReceiptInput>;
};


export type QueryGetArchivedDocumentUrlArgs = {
  input?: InputMaybe<ArchivedDocumentInput>;
};


export type QueryGetChangeCoverPricesArgs = {
  input?: InputMaybe<ChangeCoverInput>;
};


export type QueryGetOnboardingArgs = {
  input: OnboardingInput;
};


export type QueryGetServicesArgs = {
  input?: InputMaybe<ServiceInput>;
};


export type QueryHospitalSearchArgs = {
  input?: InputMaybe<HospitalSearchInput>;
};


export type QueryLimitsArgs = {
  memberId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentDatePaidToArgs = {
  input?: InputMaybe<PaymentDatePaidToInput>;
};


export type QueryPaymentHistoryWithPaginationArgs = {
  input?: InputMaybe<PaymentHistoryInput>;
};


export type QueryPerformBenefitEnquiryArgs = {
  input?: InputMaybe<BenefitEnquiryInput>;
};


export type QueryPharmacyItemsSearchArgs = {
  input?: InputMaybe<DrugSearchInput>;
};


export type QueryProductArgs = {
  productId: Scalars['ID']['input'];
};


export type QueryProductsWithPricesArgs = {
  input?: InputMaybe<ProductsWithPricesInput>;
};


export type QueryProductsWithServicesArgs = {
  input?: InputMaybe<ProductWithServiceInput>;
};


export type QueryProviderSearchArgs = {
  input?: InputMaybe<ProviderSearchInput>;
};


export type QueryRecommendProductsArgs = {
  input?: InputMaybe<RecommendProductsInput>;
};


export type QueryResolveProductIdArgs = {
  internalProductId: Scalars['ID']['input'];
};


export type QueryServedWaitingPeriodsArgs = {
  input: ServedWaitingPeriodInput;
};


export type QueryValidatePhoneAndEmailDuplicationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  primaryMemberId: Scalars['String']['input'];
};


export type QueryValidateReferralCodeArgs = {
  referralCode?: InputMaybe<Scalars['String']['input']>;
};

export type Rating = {
  __typename?: 'Rating';
  extras?: Maybe<Scalars['Int']['output']>;
  hospital?: Maybe<Scalars['Int']['output']>;
};

export type Receipt = {
  __typename?: 'Receipt';
  receipt?: Maybe<Scalars['String']['output']>;
};

export type ReceiptInput = {
  reference?: InputMaybe<Scalars['String']['input']>;
  requestedFromPagePointer?: InputMaybe<Scalars['String']['input']>;
};

export type ReceiveMarketing = {
  __typename?: 'ReceiveMarketing';
  email?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Boolean']['output']>;
};

export type ReceiveMarketingInput = {
  email?: InputMaybe<Scalars['Boolean']['input']>;
  sms?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RecommendProducts = {
  __typename?: 'RecommendProducts';
  extras?: Maybe<Scalars['ID']['output']>;
  hospital?: Maybe<Scalars['ID']['output']>;
};

export type RecommendProductsInput = {
  /** Date of birth in standard format DD/MM/YYYY */
  dob: Scalars['String']['input'];
  scale: Scalars['String']['input'];
};

export type ReferralHistoryItem = {
  __typename?: 'ReferralHistoryItem';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  dateNominated?: Maybe<Scalars['String']['output']>;
  datePaid?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RegisterPayLoad = {
  __typename?: 'RegisterPayLoad';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ReissueCardInput = {
  memberId: Scalars['String']['input'];
};

export type ReissueCardResponse = {
  __typename?: 'ReissueCardResponse';
  memberId: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** This is actually an instance of type Product but better expose only what we need for now. */
export type RelatedProduct = {
  __typename?: 'RelatedProduct';
  id: Scalars['ID']['output'];
};

export type RelatedProducts = {
  __typename?: 'RelatedProducts';
  extras?: Maybe<RelatedProduct>;
  hospital?: Maybe<RelatedProduct>;
};

export type Scales = {
  __typename?: 'Scales';
  selectable?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  supported?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export enum SearchTypes {
  Doctor = 'doctor',
  Hospital = 'hospital',
  Provider = 'provider'
}

export type SendMfaInput = {
  channel?: InputMaybe<ChannelType>;
};

export type ServedWaitingPeriod = {
  __typename?: 'ServedWaitingPeriod';
  calculatedWaitingPeriodEndDate?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  extrasLimitId?: Maybe<Scalars['String']['output']>;
  itemId?: Maybe<Scalars['String']['output']>;
  /**
   * This field indicates the service is part of the Flexi service.
   * Waiting period services are returned flattened.
   * Consumers can use this field to group Flexi services again.
   */
  serviceId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statuses?: Maybe<Array<Maybe<ServedWaitingPeriodStatuses>>>;
};

export type ServedWaitingPeriodInput = {
  joinDate: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  productId: Scalars['String']['input'];
};

export type ServedWaitingPeriodStatuses = {
  __typename?: 'ServedWaitingPeriodStatuses';
  endDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Service = {
  __typename?: 'Service';
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  serviceId: Scalars['ID']['output'];
};

export type ServiceDates = {
  __typename?: 'ServiceDates';
  ambulance?: Maybe<Scalars['String']['output']>;
  extras?: Maybe<Scalars['String']['output']>;
  hospital?: Maybe<Scalars['String']['output']>;
};

export type ServiceInput = {
  dob?: InputMaybe<Scalars['String']['input']>;
  productType: ProductType;
};

export type SuspendedDetails = {
  __typename?: 'SuspendedDetails';
  dateFrom?: Maybe<Scalars['String']['output']>;
  dateTo?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type UpdateCommunicationPreferencesInput = {
  primaryContactByEmail?: InputMaybe<Scalars['Boolean']['input']>;
  receiveMarketing?: InputMaybe<ReceiveMarketingInput>;
};

export type UpdateCreditAccountInput = {
  bsb: Scalars['String']['input'];
  channel?: InputMaybe<ChannelType>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
};

export type UpdateIncomeTierInput = {
  incomeTier: Scalars['String']['input'];
};

export type UpdateMemberInput = {
  channel?: InputMaybe<ChannelType>;
  confirmStudentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  hasSpousalAuthority?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['String']['input'];
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export type UpdateMembersInput = {
  channel?: InputMaybe<ChannelType>;
  members?: InputMaybe<Array<InputMaybe<MemberEmailPhoneInput>>>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePaymentFrequencyInput = {
  frequency: Scalars['String']['input'];
  nextPaymentDate: Scalars['String']['input'];
  trial?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdatePrimaryMemberInput = {
  address?: InputMaybe<AddressByTypeInput>;
  channel?: InputMaybe<ChannelType>;
  email?: InputMaybe<Scalars['String']['input']>;
  mfaToken?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<PhoneInput>;
};

export type UploadDocumentsInput = {
  documentType: Scalars['String']['input'];
  files: Array<Scalars['Upload']['input']>;
};

export type UserLoginInput = {
  grant_type: Scalars['String']['input'];
  memberId?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  refresh_token?: InputMaybe<Scalars['String']['input']>;
};

export type ValidatedReferralCode = {
  __typename?: 'ValidatedReferralCode';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type WaitingPeriod = {
  __typename?: 'WaitingPeriod';
  existing?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<Scalars['String']['output']>;
};

export type WaitingPeriodForItem = {
  __typename?: 'WaitingPeriodForItem';
  waitingPeriodEndDate?: Maybe<Scalars['String']['output']>;
};

export type WaitingPeriodForItemInput = {
  memberId: Scalars['String']['input'];
  serviceId: Scalars['String']['input'];
  serviceItemId: Scalars['String']['input'];
};

export type YouthDiscount = {
  __typename?: 'YouthDiscount';
  clientYouthDiscountAge?: Maybe<Scalars['Int']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  spouseYouthDiscountAge?: Maybe<Scalars['Int']['output']>;
};

export type ClaimHistoryAllResults = {
  __typename?: 'claimHistoryAllResults';
  canFetchMore: Scalars['Boolean']['output'];
  fetchedYear: Scalars['Int']['output'];
  results?: Maybe<Array<Maybe<Claim>>>;
};

export type CreateLeadInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  excess?: InputMaybe<Scalars['Float']['input']>;
  frequency?: InputMaybe<Scalars['String']['input']>;
  gaClientId?: InputMaybe<Scalars['String']['input']>;
  hasCashAssistInterest?: InputMaybe<Scalars['Boolean']['input']>;
  income?: InputMaybe<Scalars['Float']['input']>;
  incomeBracket?: InputMaybe<Scalars['String']['input']>;
  incomeTier?: InputMaybe<Scalars['String']['input']>;
  incomeType?: InputMaybe<Scalars['String']['input']>;
  isMember?: InputMaybe<Scalars['Boolean']['input']>;
  leadId?: InputMaybe<Scalars['String']['input']>;
  marketingOptIn?: InputMaybe<Scalars['Boolean']['input']>;
  memberCallbackReason?: InputMaybe<Scalars['String']['input']>;
  memberId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerAge?: InputMaybe<Scalars['Int']['input']>;
  partnerDob?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productType?: InputMaybe<Scalars['String']['input']>;
  rebateAgeBracket?: InputMaybe<Scalars['String']['input']>;
  rebateAgeTier?: InputMaybe<Scalars['String']['input']>;
  rebatePercentage?: InputMaybe<Scalars['String']['input']>;
  scale?: InputMaybe<Scalars['String']['input']>;
  source: Scalars['String']['input'];
  state?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  youthDiscountPercentage?: InputMaybe<Scalars['Float']['input']>;
};
